export const LANDING = '/';
export const UPLOAD = '/upload';
export const UPLOADACCESSCODE = '/upload/:ac';
export const BRANDED_LANDING = '/c/:company';
export const BRANDED_UPLOAD = '/c/:company/upload';
export const BRANDED_UPLOADACCESSCODE = '/c/:company/upload/:ac';